<template>
  <main-container>
    <reports-template />
  </main-container>
</template>

<script>
import ReportsTemplate from "@/app/reports/components/templates/ReportsTemplate.vue";
import MainContainer from "@/app/shared/components/organisms/MainContainer.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ReportsTemplate,
    MainContainer,
  },
});
</script>
